import React, { useContext, useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import LeftSidePopupLayout from "../../popup/modal-layout";
import { GlobalContext } from "../../../context/Context";
import { useApiCall } from "../../custom-hooks/api-call";
import Swal from "sweetalert2";
import DataNotFound from "../../ui/loader/data-not-found";
import { SelectSearch } from "../../form/form-layout";
import { CalendarCheck2, ChevronDown } from "lucide-react";
import {
  Bank,
  Benefit,
  Branch,
  CarModel,
  CarName,
  CarRegistration,
  CarVariant,
  CNIC,
  Date as DateIcon,
  DateOfConfirmation,
  DateOfExpiry,
  DateOfJoining,
  DefaultIcon,
  DegreeMajors,
  DegreeTitle,
  Depart,
  Designation,
  Driver,
  Education,
  Email,
  EmpType,
  Experience,
  FoodEligible,
  HiringReason,
  Holiday,
  Incident,
  InstituteName,
  JobSite,
  JobTitle,
  JobType,
  Meta,
  Month,
  Name,
  NoOfPosition,
  Notice,
  Phone,
  Platform,
  Position,
  Range,
  RationEligible,
  Reporting,
  Salary,
  Service,
  Shift,
  Skills,
  Status,
  Subject,
  TaxSlab,
  TicketCategory,
  TicketSubCategory,
  TicketType,
  Van,
  VendorType,
  Year,
} from "../../icons/filter-icon";
import SearchLGIcon from "../../icons/search-lg";

const iconRules = [
  { keys: ["job title"], Icon: JobTitle },
  { keys: ["hiring reason"], Icon: HiringReason },
  { keys: ["no of position", "number of position"], Icon: NoOfPosition },
  { keys: ["position"], Icon: Position },
  { keys: ["education"], Icon: Education },
  { keys: ["skills"], Icon: Skills },
  { keys: ["experience"], Icon: Experience },
  { keys: ["platform"], Icon: Platform },
  { keys: ["job site"], Icon: JobSite },
  { keys: ["job type"], Icon: JobType },
  { keys: ["branch"], Icon: Branch },
  { keys: ["ticket type"], Icon: TicketType },
  { keys: ["ticket category"], Icon: TicketCategory },
  { keys: ["ticket sub category"], Icon: TicketSubCategory },
  { keys: ["driver"], Icon: Driver },
  { keys: ["incident"], Icon: Incident },
  { keys: ["car model"], Icon: CarModel },
  { keys: ["car variant"], Icon: CarVariant },
  { keys: ["car name", "car"], Icon: CarName },
  { keys: ["tax", "tax slab"], Icon: TaxSlab },
  { keys: ["foodpanda eligible"], Icon: FoodEligible },
  { keys: ["ration eligible"], Icon: RationEligible },
  {
    keys: ["date of confirmation", "confirmation date", "conform date"],
    Icon: DateOfConfirmation,
  },
  { keys: ["date of joining", "joining date"], Icon: DateOfJoining },
  { keys: ["date of expiry", "expiry date"], Icon: DateOfExpiry },
  { keys: ["cnic"], Icon: CNIC },
  { keys: ["bank"], Icon: Bank },
  { keys: ["email"], Icon: Email },
  { keys: ["degree title"], Icon: DegreeTitle },
  { keys: ["service"], Icon: Service },
  { keys: ["degree major", "degree majors"], Icon: DegreeMajors },
  { keys: ["employee type"], Icon: EmpType },
  { keys: ["department", "depart", "dept"], Icon: Depart },
  { keys: ["designation"], Icon: Designation },
  { keys: ["status"], Icon: Status },
  { keys: ["notice"], Icon: Notice },
  { keys: ["shift"], Icon: Shift },
  { keys: ["reporting", "authority"], Icon: Reporting },
  { keys: ["meta"], Icon: Meta },
  { keys: ["holiday"], Icon: Holiday },
  { keys: ["salary", "amount", "rent"], Icon: Salary },
  { keys: ["benefit"], Icon: Benefit },
  { keys: ["phone", "mobile", "contact"], Icon: Phone },
  { keys: ["month"], Icon: Month },
  { keys: ["year"], Icon: Year },
  { keys: ["range"], Icon: Range },
  { keys: ["van"], Icon: Van },
  { keys: ["date"], Icon: DateIcon },
  { keys: ["subject"], Icon: Subject },
  { keys: ["car registration", "registration"], Icon: CarRegistration },
  {
    keys: ["institute name", "institute", "school", "college"],
    Icon: InstituteName,
  },
  { keys: ["name", "employee", "emp", "employ"], Icon: Name },
  { keys: ["type", "vendor type"], Icon: VendorType },
];

const customDate = [
  { label: "Last 15 Days", val: "last_15_days" },
  { label: "Last 30 Days", val: "last_30_days" },
  { label: "Last 60 Days", val: "last_60_days" },
  { label: "Last 90 Days", val: "last_90_days" },
];

const DynamicFilter = ({
  onClose,
  onSave = () => { },
  data,
  returnData = [],
  editingFilters,
  selectFilterName = "My Filter",
  saveFilter,
  apiUrl,
  saveFilterOff = false,
}) => {
  const [filters, setFilters] = useState([]);
  const [status, setStatus] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [onSaveFilter, setOnSaveFilter] = useState(saveFilter);
  const [searchedValue, setSearchedValue] = useState("");

  const [customDateFilter, setCustomDateFilter] = React.useState({
    start: "",
    end: "",
  });

  const searchResult = onSaveFilter
    ? onSaveFilter?.filter((item) =>
      item.filter_name.toLowerCase().includes(searchedValue.toLowerCase()),
    )
    : [];

  useEffect(() => {
    if (returnData?.length) {
      const merged = data.map((item) => {
        const override = returnData.find((o) => o.name === item.name);
        return override ? override : item;
      });
      setFilters(merged);
    } else {
      setFilters(data);
    }
    setDepartmentList(state?.getDropdowns?.departmentList);
  }, [data, returnData]);

  const closeFun = () => {
    setStatus(false);
    setTimeout(() => {
      onClose();
    }, 200);
  };

  const handleCheckboxToggle = (index) => {
    console.log("FUNCTION RUN");
    const updated = [...filters];
    updated[index].isChecked = !updated[index].isChecked;
    setFilters(updated);
  };

  const handleValueChange = (index, e) => {
    const updated = [...filters];
    updated[index].value = e.target.value;
    setFilters(updated);
  };

  const handleBetweenChange = (index, pos, val) => {
    const updated = [...filters];
    const current = updated[index];
    const range = [...current.value];

    // ✅ Special handling ONLY for date type
    if (current.betweenType === "date") {
      // FROM date changed
      if (pos === 0) {
        // If FROM >= TO → reset TO
        if (range[1] && val >= range[1]) {
          range[0] = val;
          range[1] = "";
        } else {
          range[0] = val;
        }

        // TO date changed
        if (pos === 1) {
          range[1] = val;
        }
      } else {
        // Non-date between (salary, number, etc.)
        range[pos] = val;
      }

      current.value = range;
      updated[index] = current;
      setFilters(updated);
    } else {
      range[pos] = val;
      updated[index].value = range;
      setFilters(updated);
    }
  };

  const handleSubmit = () => {
    const formatted = filters
      .filter((f) => {
        return (
          f.value != "" &&
          f.value != null &&
          f.value != undefined &&
          f.value != [] &&
          f.value != ["", ""]
        );
      })
      .map((f) => {
        if (Array.isArray(f.value) && f.selectedOpt == "between") {
          return !f.value[0]
            ? { ...f, value: [f.value[1], f.value[1]] }
            : !f.value[1]
              ? { ...f, value: [f.value[0], f.value[0]] }
              : { ...f };
        } else {
          return { ...f };
        }
      });
    console.log("formatted", formatted);
    const filterName = saveFilterName;
    onSave(formatted, filterName, editingFilter);
    closeFun();
  };

  const [editingFilter, setEditingFilter] = useState(editingFilters);
  const [saveFilterName, setSaveFilterName] = useState(selectFilterName);
  const [saveFilterID, setSaveFilterID] = useState(null);
  const [saveFilterIs, setSaveFilterIs] = useState(false);
  const [originalFilters, setOriginalFilters] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const wrapperRef = useRef(null);

  const handleSaveFilter = async () => {
    const formatted = filters
      .filter((f) => f.isChecked)
      .map((f) => ({
        ...f,
      }))
      .filter((f) =>
        Array.isArray(f.value) ? f.value.length > 0 : f.value !== "",
      );

    if (formatted.length === 0) {
      Swal.fire(
        "No filters selected",
        "Please select and fill filters before saving.",
        "warning",
      );
      return;
    }

    // Original filter name if editing
    const originalName = editingFilter?.filterName || "";

    let confirmBtnText = editingFilter ? "Updated" : "Saved";

    const { value: filterName } = await Swal.fire({
      title: editingFilter ? "Update filter name" : "Enter filter name",
      input: "text",
      inputValue: originalName,
      inputPlaceholder: "Enter a name for this filter",
      showCancelButton: true,
      confirmButtonText: confirmBtnText,
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Filter name is required";
        }
      },
      didOpen: (popup) => {
        const input = popup.querySelector("input");
        const confirmBtn = popup.querySelector(".swal2-confirm");

        input.addEventListener("input", () => {
          if (editingFilter) {
            // Check if input differs from original
            if (input.value.trim() !== originalName.trim()) {
              confirmBtn.textContent = "Duplicate";
              confirmBtnText = "Duplicate";
            } else {
              confirmBtn.textContent = "Updated";
              confirmBtnText = "Updated";
            }
          }
        });
      },
    });

    if (!filterName) {
      return; // Cancelled or empty input
    }

    try {
      const apiData = {
        api_url: apiUrl,
        filter_name: filterName.trim(),
        filters_json: formatted,
      };

      // If editing, send filter_id too
      if (editingFilter?.filterId) {
        apiData.filter_id = editingFilter.filterId;
      }

      await apiCall({
        method: "post",
        url: "list-config/save-filters",
        data: JSON.stringify(apiData),
      });

      Swal.fire("Success", `Filter ${confirmBtnText} successfully`, "success");

      onSave(formatted, filterName.trim(), editingFilter);
      setEditingFilter(null);
    } catch (error) {
      console.warn("Error saving filter:", error);
      Swal.fire("Error", "Failed to save filter. Please try again.", "error");
    }
  };

  const handleDeletFilter = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this filter? This action cannot be undo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      const apiData = JSON.stringify({ filter_id: id });
      await apiCall({
        method: "post",
        url: `list-config/delete-filter/${id}`,
        data: apiData,
      });
      setOnSaveFilter((prevFilters) => prevFilters.filter((f) => f.id !== id));

      if (editingFilter?.filterId === id) {
        setEditingFilter(null); // reset editingFilter if it was deleted
        const reset = filters.map((f) => ({
          ...f,
          isChecked: false,
          value:
            f.field === "search_by_salary" ||
              f.field === "search_by_joining_date"
              ? ["", ""]
              : "",
          selectedOperator:
            f.field === "search_by_salary"
              ? "between"
              : f.field === "search_by_joining_date"
                ? "is"
                : "contains",
        }));
        setFilters(reset);
        setSaveFilterName("My Filter");
        setSaveFilterID(null);
      }
      Swal.fire("Deleted!", "Your filter has been deleted.", "success");
    } catch (error) {
      console.warn("Error deleting filter:", error);
      Swal.fire("Error", "Failed to delete filter. Please try again.", "error");
    }
  };

  const handleSaveFilterChange = (rdata, filterName, filterId) => {
    const merged = data.map((item) => {
      const override = rdata.find((o) => o.name === item.name);
      return override ? override : item;
    });

    setFilters(merged);
    setOriginalFilters(JSON.parse(JSON.stringify(merged))); // deep copy
    setEditingFilter({ filterName, filterId });
    setSaveFilterName(filterName);
  };

  // Compare function to check if filters changed
  const isFiltersChanged = () => {
    return JSON.stringify(filters) !== JSON.stringify(originalFilters);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSaveFilterIs(false);
      }
    }

    if (saveFilterIs) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [saveFilterIs]);

  //
  const getToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const getDateBeforeDays = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const getNextDate = (dateStr) => {
    if (!dateStr) return undefined;

    const date = new Date(dateStr);
    date.setDate(date.getDate());

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const clearSingleFilter = (index) => {
    const updated = [...filters];
    updated[index].value = "";
    setFilters(updated);
  };

  // const getFilterIcon = (filter) => {
  //   const text = (
  //     filter?.label ||
  //     filter?.name ||
  //     ""
  //   ).toLowerCase();

  //   const matchedKey = Object.keys(listOfIcon).find((key) =>
  //     text.includes(key)
  //   );

  //   return matchedKey ? listOfIcon[matchedKey] : DefaultIcon;
  // };

  const getFilterIcon = (filter) => {
    const text = (filter?.label || filter?.name || "")
      .toLowerCase()
      .replace(/[_-]/g, " ");

    const rule = iconRules.find((rule) =>
      rule.keys.some((key) => text.includes(key)),
    );

    return rule ? rule.Icon : DefaultIcon;
  };

  return (
    <LeftSidePopupLayout
      popupStatus={status}
      className={` ${Style.customize_modal}`}
    >
      {/* Search Input */}
      {!saveFilterOff && (
        <div className="border-gray-200">
          <div className="bg-white relative rounded-lg w-full border border-[#E1E4EA] shadow-[0_1px_2px_0_rgba(10,13,18,0.05)]">
            <div className="relative flex items-center px-3 py-2 gap-2">
              <SearchLGIcon />
              <input
                type="text"
                placeholder="Search"
                className="flex-1 text-gray-500 text-base outline-none bg-transparent"
                value={searchedValue}
                onChange={(e) => setSearchedValue(e.target.value)}
                onFocus={() => setSaveFilterIs(true)}
                onBlur={() => setTimeout(() => setSaveFilterIs(false), 100)}
              />
              <div className="flex items-center p-1 border border-[#E1E4EA] rounded text-[#717680] text-[12px] font-medium">
                ⌘K
              </div>
            </div>
            {saveFilterIs && (
              <div className={Style.myFilter__wrap}>
                {searchResult?.length ? (
                  searchResult.map((ele, idx) => {
                    return (
                      <div
                        className={`${Style.myFilter__items} ${saveFilterName == ele?.filter_name
                          ? Style.isActive
                          : ""
                          }`}
                        key={ele.id || idx}
                        onClick={() => {
                          console.log("Test");
                          handleSaveFilterChange(
                            ele?.config_filters,
                            ele?.filter_name,
                            ele?.id,
                          );
                          setSearchedValue(ele?.filter_name);
                          setSaveFilterIs(false);
                          setSaveFilterID(ele?.id);
                        }}
                      >
                        <p>{ele.filter_name}</p>
                      </div>
                    );
                  })
                ) : (
                  <div className={Style.myFilter__items}>
                    <DataNotFound
                      onlyText={true}
                      title={"Filter"}
                      className={Style.noDataFound}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Filters Header */}
      <div className="border-gray-200">
        <div className="flex items-center justify-between">
          <h2 className="text-[20px] font-semibold text-[#1E1E1E]">Filters</h2>
          <div className="flex items-center gap-[10px]">
            <button
              className="text-[14px] font-semibold text-[#999]"
              onClick={() => {
                setSaveFilterName("My Filter");
                onSave([]); // Clear filters in parent
                closeFun(); // Optional: Close popup after clearing
              }}
            >
              Clear All
            </button>
            {!saveFilterOff && (
              <>
                <div className="size-2 rounded-full bg-[#999]" />
                <button
                  className="text-[14px] font-semibold cursor-pointer text-[#0057FB] disabled:cursor-not-allowed disabled:opacity-70"
                  onClick={handleSaveFilter}
                  disabled={
                    editingFilter
                      ? !isFiltersChanged() // disable if no changes
                      : filters.filter(
                        (f) =>
                          f.value &&
                          (f.field === "search_by_salary"
                            ? f.value[0] || f.value[1]
                            : f.value),
                      ).length === 0
                  }
                >
                  Save Filters
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Filter Sections divide-y divide-gray-200  */}
      <div className="overflow-hidden overflow-y-auto min-h-[470px]">
        {filters.map((filter, index) => {
          const { Icon } = filter;
          const Icons = Icon ? Icon : getFilterIcon(filter);
          return (
            <div
              key={index}
              className={`border ${index == filters?.length - 1 ? "" : "border-b-0"} px-[16px] flex flex-col gap-[16px] py-[16px] border-[#DFDFDF] bg-white hover:bg-gray-50 transition-colors cursor-pointer`}
              onClick={() => handleCheckboxToggle(index)}
            >
              <div className="w-full flex items-center justify-between hover:bg-gray-50 transition-colors">
                <div className="flex items-center gap-[10px]">
                  {Icons ? <Icons /> : <DefaultIcon />}

                  <span className="text-[14px] font-[500] text-[#0E121B]">
                    {filter?.label ? (
                      <>{filter?.label}</>
                    ) : (
                      <>
                        {filter?.name?.includes("_")
                          ? `${filter?.name?.replaceAll("_", " ")}`
                          : filter?.name}
                      </>
                    )}
                  </span>
                </div>
                <div className="flex items-center gap-[5px]">
                  {filter?.value != "" &&
                    filter?.value != [] &&
                    filter?.value != ["", ""] ? (
                    <button
                      className="text-[14px] font-medium text-[#999] hover:text-gray-700"
                      onClick={(e) => {
                        e.stopPropagation();
                        clearSingleFilter(index);
                      }}
                    >
                      Clear
                    </button>
                  ) : null}
                  <ChevronDown
                    className={`size-4 text-[#000] transition-transform ${filter.isChecked ? "rotate-180" : "rotate-0"}`}
                  />
                </div>
              </div>

              {filter.isChecked && (
                <div className="px-[10px] py-[12px] flex flex-col gap-[20px] bg-[#F3F3F3] rounded-[8px]">
                  {filter?.selectedOpt == "between" &&
                    filter.betweenType === "date" ? (
                    <>
                      <div className="flex flex-wrap justify-between w-full">
                        {customDate?.map((shortcut) => (
                          <button
                            key={shortcut.val}
                            onClick={(e) => {
                              e.stopPropagation();
                              const today = getToday();

                              let days = 0;

                              if (shortcut.val === "last_15_days") days = 15;
                              if (shortcut.val === "last_30_days") days = 30;
                              if (shortcut.val === "last_60_days") days = 60;
                              if (shortcut.val === "last_90_days") days = 90;

                              const startDate = getDateBeforeDays(days);

                              handleBetweenChange(index, 0, startDate);
                              handleBetweenChange(index, 1, today);

                              setFilterDate(shortcut.val);
                            }}
                            className={`text-center py-2 rounded-[10px] text-[11px] w-[23%] hover:bg-gray-300 transition-all hover:shadow ${filterDate == shortcut?.val ? "bg-gray-400" : "bg-gray-200"}`}
                          >
                            <span className="flex justify-center">
                              {/* <CalendarCheck2 size={16} /> */}

                              {shortcut.label}
                            </span>
                          </button>
                        ))}
                      </div>
                      <div onClick={(e) => e.stopPropagation()}>
                        <input
                          type="date"
                          value={filter.value[0] || ""}
                          onChange={(e) => {
                            const val = e.target.value;

                            setFilterDate(""); // 👈 add this line

                            handleValueChange(index, {
                              target: { value: "" },
                            });

                            handleBetweenChange(index, 0, val);
                          }}
                          max={getToday()}
                          placeholder={`Start ${filter?.label || filter?.name?.includes("_") || filter?.name?.replaceAll("_", " ") || filter?.name}`}
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                        />
                      </div>

                      <div onClick={(e) => e.stopPropagation()}>
                        <input
                          type="date"
                          value={filter.value[1] || ""}
                          min={getNextDate(filter.value[0])}
                          max={getToday()}
                          onChange={(e) => {
                            const val = e.target.value;
                            setFilterDate("");
                            if (typeof (filter?.value) == "string") {
                              handleValueChange(index, {
                                target: { value: "" },
                              });
                            }

                            handleBetweenChange(index, 1, val); // if you have existing handler
                          }}
                          placeholder={`End ${filter?.label || filter?.name?.includes("_") || filter?.name?.replaceAll("_", " ") || filter?.name}`}
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                        />
                      </div>
                    </>
                  ) : filter?.selectedOpt == "between" ? (
                    <>
                      <div
                        className=""
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <input
                          type={filter?.betweenType}
                          value={filter.value[0] || ""}
                          onChange={(e) => {
                            // console.log("EEE", e);
                            // console.log("val", e.target.value);
                            handleBetweenChange(index, 0, e.target.value);
                          }}
                          max={
                            filter.betweenType === "date"
                              ? getToday()
                              : undefined
                          }
                          placeholder={`Min ${filter?.label
                            ? filter?.label
                            : filter?.name?.includes("_")
                              ? `${filter?.name?.replaceAll("_", " ")}`
                              : filter?.name
                            }`}
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                        />
                      </div>
                      <div
                        className=""
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <input
                          type={filter?.betweenType}
                          value={filter.value[1] || ""}
                          min={
                            filter.betweenType === "date"
                              ? getNextDate(filter.value[0])
                              : undefined
                          }
                          max={
                            filter.betweenType === "date"
                              ? getToday()
                              : undefined
                          }
                          onChange={(e) =>
                            handleBetweenChange(index, 1, e.target.value)
                          }
                          placeholder={`Max ${filter?.label
                            ? filter?.label
                            : filter?.name?.includes("_")
                              ? `${filter?.name?.replaceAll("_", " ")}`
                              : filter?.name
                            }`}
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                        />
                      </div>
                    </>
                  ) : (
                    <div
                      className=""
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {filter?.type == "dropdown" ? (
                        <>
                          <SelectSearch
                            menuPosition="fixed"
                            value={filter.value}
                            styles={{
                              control: {
                                minHeight: "47px",
                              },
                            }}
                            onChange={(e) =>
                              handleValueChange(index, {
                                target: { value: e },
                              })
                            }
                            multiple={filter?.isMulti || false}
                            placeholder={`Select ${filter?.label
                              ? filter?.label
                              : filter?.name?.includes("_")
                                ? filter?.name?.replaceAll("_", " ")
                                : filter?.name
                              }`}
                            options={
                              filter?.dropdown
                                ? filter?.dropdown.map((els) => ({
                                  value: els[filter?.dropdownVal],
                                  label: els[filter?.dropdownKey],
                                }))
                                : departmentList?.map((els) => ({
                                  value: els?.title,
                                  label: els?.title,
                                }))
                            }
                          />
                        </>
                      ) : (
                        <input
                          className="w-full rounded-[5px] py-[14px] px-[16px] border border-[#DFDFDF] bg-white text-[14px] text-[#0E121B] font-medium"
                          type={filter?.type}
                          value={filter.value}
                          onChange={(e) => handleValueChange(index, e)}
                          placeholder={`${filter?.label
                            ? filter?.label
                            : filter?.name?.includes("_")
                              ? `${filter?.name?.replaceAll("_", " ")}`
                              : filter?.name
                            }`}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="flex gap-3">
        <button
          onClick={closeFun}
          className="flex-1 px-6 py-[17px] border border-[#1E1E1E] rounded-[8px] text-[16px] font-semibold text-[#0E121B] bg-white hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          className="flex-1 px-6 py-[17px] bg-[#0057FB] rounded-[8px] text-[16px] font-semibold text-white hover:bg-blue-700 transition-colors"
        >
          Submit
        </button>
      </div>
      {/* </div> */}
    </LeftSidePopupLayout>
  );
};

export default DynamicFilter;
